import axiosRetry from 'axios-retry';
import { axiosWithHeaders } from '@innovyze/lib_get_service';
import config from './config.api';

const sensors = axiosWithHeaders({
	service: 'userManagement',
	config,
});

axiosRetry(sensors, {
	retries: 3,
	retryDelay: retryCount => {
		return retryCount * 1000;
	},
});

export default sensors;
